import { submitToApi } from 'awsApi'
import { call, put } from 'redux-saga/effects'
import { VouchersActions } from 'store/models/vouchers'
import { URL } from './endpoints'

const platform = 'supplier'
const getSupplierId = () => JSON.parse(localStorage.getItem('supplier')).supplierId

export function* getVouchers() {
    try {
        const { message, payload } = yield call(() =>
            submitToApi({
                path: URL.VOUCHERS.V3_VOUCHERS_SUPPLIER,
                platform,
                query: { supplierId: getSupplierId() },
                url: URL.VOUCHERS.BASE,
            })
        )
        return payload.data.length
            ? yield put(VouchersActions.getVouchersSuccess(payload.data))
            : yield put(VouchersActions.getVouchersFailure(message))
    } catch (error) {
        yield put(VouchersActions.getVouchersFailure(error))
    }
}

export function* getVouchersDetails() {
    try {
        const { message, payload } = yield call(() =>
            submitToApi({
                path: URL.VOUCHERS.V4_VOUCHERS_SUPPLIER,
                platform,
                query: { supplierId: getSupplierId() },
                url: URL.VOUCHERS.BASE,
            })
        )
        if (message?.includes('not found')) {
            return yield put(VouchersActions.getVouchersDetailsFailure('No vouchers have been uploaded yet.'))
        }
        yield put(VouchersActions.getVouchersDetailsSuccess(payload.data))
    } catch (error) {
        yield put(VouchersActions.getVouchersDetailsFailure(error))
    }
}

export function* uploadVouchers({ body, callback }) {
    try {
        const { message, payload } = yield call(() =>
            submitToApi({
                body,
                method: 'POST',
                path: URL.VOUCHERS.V3_VOUCHERS_SUPPLIER,
                platform,
                url: URL.VOUCHERS.BASE,
            })
        )

        // message: "The vouchers have duplicate codes"
        if (message && message === 'The vouchers have duplicate codes') {
            const codes = payload.data.map(({ code }) => code).join(', ')
            callback(`The vouchers have duplicate codes: ${codes}`, 'error')
        } else {
            callback('Success', 'success')
        }

        yield put(VouchersActions.uploadVouchersSuccess())
        yield put(VouchersActions.getVouchersDetails())
    } catch (error) {
        yield put(VouchersActions.uploadVouchersFailure(error))
        callback(error, 'error')
    }
}

// Update voucher code of un-used vouchers
export function* updateVoucherCode({ body, callback }) {
    try {
        const { message } = yield call(() =>
            submitToApi({
                body,
                method: 'PUT',
                path: URL.VOUCHERS.V4_VOUCHERS_SUPPLIER,
                platform,
                url: URL.VOUCHERS.BASE,
            })
        )
        yield put(VouchersActions.updateVoucherCodeSuccess())
        yield put(VouchersActions.getVouchersDetails())
        callback(message, 'success')
    } catch (error) {
        yield put(VouchersActions.updateVoucherCodeFailure())
        callback(error, 'error')
    }
}

export function* archiveVouchers({ body, callback }) {
    try {
        const { message } = yield call(() =>
            submitToApi({
                body,
                method: 'PUT',
                path: URL.VOUCHERS.V3_VOUCHERS_SUPPLIER,
                platform,
                url: URL.VOUCHERS.BASE,
            })
        )
        yield put(VouchersActions.archiveVouchersSuccess())
        yield put(VouchersActions.getVouchersDetails())
        callback(message, 'success')
    } catch (error) {
        yield put(VouchersActions.archiveVouchersFailure(error))
        callback(error, 'error')
    }
}

export function* deleteVouchers({ body, callback }) {
    try {
        const { message } = yield call(() =>
            submitToApi({
                body,
                method: 'DELETE',
                path: URL.VOUCHERS.V3_VOUCHERS_SUPPLIER,
                platform,
                url: URL.VOUCHERS.BASE,
            })
        )

        yield put(VouchersActions.deleteVouchersSuccess())
        yield put(VouchersActions.getVouchersDetails())
        callback(message, 'success')
    } catch (error) {
        yield put(VouchersActions.deleteVouchersFailure(error))
        callback(error, 'error')
    }
}
